export const MAX_PRODUCT_PRICE_CART_COUNT = 50 as const;
